import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

const { colors } = constants;

export const stateContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "40px 20px",
  textAlign: "center",
};

export const errorIconCss: CSSObject = {
  width: "112px",
  height: "112px",
  marginBottom: "24px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const errorTitleCss: CSSObject = {
  fontSize: "18px",
  fontWeight: 600,
  color: colors.status.danger[500],
  marginBottom: "8px",
};

export const stateSubtitleCss: CSSObject = {
  fontSize: "14px",
  color: colors.ui.neutral[600],
  marginBottom: "32px",
};

export const actionButtonCss = {
  root: {
    color: colors.ui.core[600],
    textDecoration: "underline",
    background: "none",
    border: "none",
    cursor: "pointer",
    fontSize: "14px",
    padding: "8px 16px",

    "&:hover": {
      color: colors.ui.core[700],
    },
  },
};

export const stateTitleCss: CSSObject = {
  fontSize: "18px",
  fontWeight: 600,
  marginBottom: "8px",
};
